import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import displayValuesFor from "react-stockcharts/lib/tooltip/displayValuesFor";
import GenericChartComponent from "react-stockcharts/lib/GenericChartComponent";
import i18next from 'i18next';
import { isDefined, functor } from "react-stockcharts/lib/utils";
import ToolTipText from "react-stockcharts/lib/tooltip/ToolTipText";
import ToolTipTSpanLabel from "react-stockcharts/lib/tooltip/ToolTipTSpanLabel";
import config from './../../config';

class CustomOHLCTooltip extends Component {
	constructor(props) {
		super(props);
		this.renderSVG = this.renderSVG.bind(this);
	}
	renderSVG(moreProps) {
			const { displayValuesFor } = this.props;
			const {
				xDisplayFormat,
				newxDisplayFormat,
				accessor,
				volumeFormat,
				ohlcFormat,
				percentFormat,
				displayTexts,
				lastPointFromGraph,
				time,
				myFlag,
				dynamicTime,
				dynamicTimeLine,
				dynamicTimeMulti,
				livePlotData,
				zoomWidth,
				changeHover,
				candleHeader,
				lineHeader,
				MultiplelineHeader
			} = this.props;

			const { chartConfig: { width, height } } = moreProps;
			const { displayXAccessor } = moreProps;
			let currentItem = displayValuesFor(this.props, moreProps);
			currentItem = currentItem ? currentItem : lastPointFromGraph;
			let lineText = this.props.lineHeader;
			let candleText = this.props.candleHeader;
			let MultipleLineText = this.props.MultiplelineHeader;
			let flag = this.props.myFlag;
			let zoomSet = this.props.zoomWidth;
			let displayDate, open, high, low, close, volume, percent, displayprice;
			displayDate = open = high = low = close = volume = percent = displayprice = displayTexts.na;

			if (isDefined(currentItem) && isDefined(accessor(currentItem))) {
				const item = accessor(currentItem);
				let hoverTime = this.props.time;
				volume = isDefined(item.volume) ? volumeFormat(item.volume) : displayTexts.na;
				let d = new Date();
				let formatMe = timeFormat("%H:%M:%S");
				let t = formatMe(d);
				let hr = new Date(item.date).getHours();
				let mn = new Date(item.date).getMinutes();
				let sec = new Date(item.date).getSeconds();
				let newTime = hr+':'+mn+':'+sec;
				if (candleText === 'Candle Stick') {
					if (this.props.livePlotData !== undefined && (flag == 0 || this.props.dynamicTime) ) {
						displayDate = t;
						open = (this.props.livePlotData.open).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						high = (this.props.livePlotData.high).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						low = (this.props.livePlotData.low).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						close = (this.props.livePlotData.close).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					}
					else {
						displayDate = newxDisplayFormat(displayXAccessor(item));
						open = (item.open).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						high = (item.high).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						low = (item.low).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						close = (item.close).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					}
				}
				else if(lineText === 'Line'){
						if (this.props.dynamicTimeLine) {
							displayDate = formatMe(lastPointFromGraph.date);
							displayprice = (lastPointFromGraph.Price).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						}
						else {
							displayDate = newxDisplayFormat(displayXAccessor(item));
							displayprice = (currentItem.Price).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						}
						high = (lastPointFromGraph.high).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
						low = (lastPointFromGraph.low).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
				}
				else if (MultipleLineText === 'MultipleLine') {
					if (this.props.dynamicTimeMulti) {
						displayDate = formatMe(lastPointFromGraph.date);
					}
					else {
						displayDate = newxDisplayFormat(displayXAccessor(item));
					}
					high = (lastPointFromGraph.high).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					low = (lastPointFromGraph.low).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
				}
				else {
					displayDate = xDisplayFormat(displayXAccessor(item));
					open = (item.open).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					high = (item.high).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					low = (item.low).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
					close = (item.close).toLocaleString(navigator.language,{ minimumFractionDigits:ohlcFormat,maximumFractionDigits:ohlcFormat});
				}

				percent = percentFormat((item.close - item.open) / item.open);
			}

			const { origin: originProp } = this.props;
			const origin = functor(originProp);
			const [x, y] = origin(width, height);

			const itemsToDisplay = {
				displayDate,
				lineText,
				candleText,
				MultipleLineText,
				flag,
				zoomSet,
				open,
				high,
				low,
				close,
				displayprice,
				percent,
				volume,
				x,
				y
			};
			return this.props.children(this.props, moreProps, itemsToDisplay);
	}
	render() {
		return (
			<GenericChartComponent
				clip={false}
				svgDraw={this.renderSVG}
				drawOn={["mousemove"]}
			/>
		);
	}
}

CustomOHLCTooltip.propTypes = {
	className: PropTypes.string,
	accessor: PropTypes.func,
	xDisplayFormat: PropTypes.func,
	newxDisplayFormat: PropTypes.func,
	children: PropTypes.func,
	volumeFormat: PropTypes.func,
	percentFormat: PropTypes.func,
	ohlcFormat: PropTypes.number,
	origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
	fontFamily: PropTypes.string,
	fontSize: PropTypes.number,
	onClick: PropTypes.func,
	displayValuesFor: PropTypes.func,
	textFill: PropTypes.string,
	labelFill: PropTypes.string,
	displayTexts: PropTypes.object,
	newdisplayTexts: PropTypes.object,
	lastPointFromGraph: PropTypes.object,
	time: PropTypes.string,
	myFlag: PropTypes.boolean,
	dynamicTime: PropTypes.boolean,
	dynamicTimeLine:PropTypes.boolean,
	dynamicTimeMulti:PropTypes.boolean,
	livePlotData: PropTypes.object,
	zoomWidth: PropTypes.number,
	lineHeader: PropTypes.string,
	MultiplelineHeader: PropTypes.string,
	candleHeader: PropTypes.string
};


	let displayTextsDefault = {
		d: "date",
		o: "O",
		h: "H",
		l: "L",
		c: "C",
		v: "V",
		na: "n/a"
	};

	let newdisplayTextsDefault = {
		d: "time",
		o: "O",
		h: "H",
		l: "L",
		c: "C",
		v: "V",
		na: "n/a"
	};


	CustomOHLCTooltip.defaultProps = {
		accessor: d => {
			return {
				displayDate: d.displayDate,
				date: d.date,
				open: d.open,
				high: d.high,
				low: d.low,
				close: d.close,
				volume: d.volume,
				displayprice: d.displayprice
			};
		},
		xDisplayFormat: timeFormat("%Y-%m-%d"),
		newxDisplayFormat: timeFormat("%H:%M:%S"),
		volumeFormat: format(".4s"),
		percentFormat: format(".2%"),
		displayValuesFor: displayValuesFor,
		origin: [0, 0],
		children: defaultDisplay,
		displayTexts: displayTextsDefault,
		newdisplayTexts: newdisplayTextsDefault
	};


function defaultDisplay(props, moreProps, itemsToDisplay) {
	/* eslint-disable */
	const {
		className,
		textFill,
		labelFill,
		onClick,
		fontFamily,
		fontSize,
		displayTexts,
		newdisplayTexts
	} = props;
	/* eslint-enable */

	const {
		displayDate,
		lineText,
		candleText,
		MultipleLineText,
		flag,
		open,
		high,
		low,
		close,
		volume,
		displayprice,
		x,
		y,
		zoomSet
	} = itemsToDisplay;

	return (
		<g
			className={`react-stockcharts-tooltip-hover ${className}`}
			transform={`translate(${x}, ${y})`}
			onClick={onClick}
		>
			<ToolTipText
				x={0}
				y={0}
				fontFamily={fontFamily}
				fontSize={fontSize}
			>
				<ToolTipTSpanLabel
					className="tspan1"
					fill="#3178a5"
					key="label"
					x={0}
					
					dy="5">{(lineText === 'Line' || candleText === 'Candle Stick' || MultipleLineText === 'MultipleLine') ?  (zoomSet < 500 ? '  T'+': ' : ' '+i18next.t(newdisplayTexts.d)+': ') : zoomSet < 500 ? '  D'+': ' :' '+i18next.t(displayTexts.d)+': '}</ToolTipTSpanLabel>
				<tspan className="tspan2" key="value" fill={textFill} >{displayDate}</tspan>
				<ToolTipTSpanLabel className="tspan1"  fill="#3178a5" key="label_O" >{'  '+i18next.t(displayTexts.o)+': '}</ToolTipTSpanLabel>
				<tspan key="value_O" className="tspan2" fill={textFill} >{open}</tspan>
				<ToolTipTSpanLabel className="tspan1" fill="#3178a5" key="label_H" >{'  '+i18next.t(displayTexts.h)+': '}</ToolTipTSpanLabel>
				<tspan key="value_H" className="tspan2" fill={textFill} >{high}</tspan>
				<ToolTipTSpanLabel className="tspan1" fill="#3178a5" key="label_L" >{'  '+i18next.t(displayTexts.l)+': '}</ToolTipTSpanLabel>
				<tspan key="value_L" className="tspan2" fill={textFill} >{low}</tspan>
				<ToolTipTSpanLabel className="tspan1" fill="#3178a5" key="label_C" >{'  '+i18next.t(displayTexts.c)+': '}</ToolTipTSpanLabel>
				<tspan key="value_C" className="tspan2" fill={textFill} >{close}</tspan>
				<ToolTipTSpanLabel className="tspan1" fill="#3178a5" key="label_Vol" >{'  '+i18next.t(displayTexts.v)+': '}</ToolTipTSpanLabel>
				<tspan key="value_Vol" className="tspan2" fill={textFill} >{volume}</tspan>
				<ToolTipTSpanLabel className="tspan1" fill="#3178a5" >{lineText === 'Line' ? '  '+i18next.t('price')+': ' : ' '}</ToolTipTSpanLabel>
				<tspan className="tspan2" >{lineText === 'Line' ? displayprice : null}</tspan>

			</ToolTipText>
		</g>
	);
}

export default CustomOHLCTooltip;
